import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { MaintenanceMessage } from "src/app/models/maintenance-message.model";
import { lastValueFrom } from "rxjs";

@Injectable({
    providedIn: 'root'
  })
  export class MaintenanceMessageService {
    __URL_API__  = `${environment.URL_Back}`; 

    constructor(private http: HttpClient) {
    }

    async getMaintenanceMessage() {
            var message = await lastValueFrom(this.http.get<MaintenanceMessage>(`${environment.URL_Back}MaintenanceMessage`));
            return message;
    }


  }